module.exports = "<app-google-maps (onMapInitialized)=\"onMapInitialized()\"></app-google-maps>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/auto-routing-results/components/autorouting-map/autorouting-map.component.html
// module id = 2373
// module chunks = 66